import Phaser from 'phaser';
import { WORLD } from '../world.ts';
import { loadProgress } from '../game/storage.ts';
import { getBeyDef, ROSTER, artBase } from '../game/stats.ts';

export class TitleScene extends Phaser.Scene {
  constructor() {
    super('Title');
  }

  create(): void {
    const { width, height } = WORLD;
    this.cameras.main.setBackgroundColor('#05060a');
    backdropGlow(this);

    this.add
      .text(width / 2, height * 0.32, 'BEYBLADE', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '110px',
        fontStyle: 'bold',
        color: '#ffffff',
        stroke: '#1b2a4a',
        strokeThickness: 12,
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.45, 'SPIN ARENA', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '40px',
        fontStyle: 'bold',
        color: '#ffd23b',
        stroke: '#000000',
        strokeThickness: 6,
      })
      .setOrigin(0.5);

    const prompt = this.add
      .text(width / 2, height * 0.575, 'ENTER  —  Tournament', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '32px',
        fontStyle: 'bold',
        color: '#ffd23b',
      })
      .setOrigin(0.5);
    this.tweens.add({ targets: prompt, alpha: 0.35, duration: 700, yoyo: true, repeat: -1 });

    this.add
      .text(width / 2, height * 0.64, 'X  —  Exhibition (single match)', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '24px',
        color: '#cfe0ff',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.695, '2  —  2-Player Versus', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '24px',
        color: '#cfe0ff',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.75, 'I  —  How to Play', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '20px',
        color: '#8aa0c8',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.965, 'P1: Arrows/Space/Shift/C/E    P2: WASD/F/T/V/R    P pause   M mute', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '18px',
        color: '#8aa0c8',
      })
      .setOrigin(0.5);

    this.input.keyboard!.once('keydown-ENTER', () =>
      this.scene.start('Select', { mode: 'tournament' }),
    );
    this.input.keyboard!.once('keydown-X', () =>
      this.scene.start('Select', { mode: 'exhibition' }),
    );
    this.input.keyboard!.once('keydown-TWO', () =>
      this.scene.start('Select', { mode: 'versus' }),
    );
    this.input.keyboard!.once('keydown-NUMPAD_TWO', () =>
      this.scene.start('Select', { mode: 'versus' }),
    );
    this.input.once('pointerdown', () => this.scene.start('Select', { mode: 'tournament' }));
    this.input.keyboard!.once('keydown-I', () => this.scene.start('Help'));

    this.showProgress();
  }

  /** Show persisted championships + the hard-mode option once unlocked. */
  private showProgress(): void {
    const { width, height } = WORLD;
    const prog = loadProgress();
    if (prog.tournamentsWon > 0) {
      this.add
        .text(width / 2, height * 0.855, `🏆 Championships: ${prog.tournamentsWon}`, {
          fontFamily: 'Trebuchet MS, sans-serif',
          fontSize: '20px',
          color: '#ffd23b',
        })
        .setOrigin(0.5);
      // Champion bey faces with a check.
      const champs = prog.championIds.filter((id) => id === 'custom' || ROSTER.some((b) => b.id === id));
      const startX = width / 2 - ((champs.length - 1) * 50) / 2;
      champs.forEach((id, i) => {
        const art = id === 'custom' ? 'phoenix' : artBase(getBeyDef(id));
        this.add.sprite(startX + i * 50, height * 0.905, `bey-${art}-face`).setDisplaySize(36, 36);
      });
    }
    if (prog.hardUnlocked) {
      const h = this.add
        .text(width / 2, height * 0.805, "H  —  Champion's Gauntlet (hard)", {
          fontFamily: 'Trebuchet MS, sans-serif',
          fontSize: '22px',
          fontStyle: 'bold',
          color: '#ff5b5b',
        })
        .setOrigin(0.5);
      this.tweens.add({ targets: h, alpha: 0.4, duration: 800, yoyo: true, repeat: -1 });
      this.input.keyboard!.once('keydown-H', () =>
        this.scene.start('Select', { mode: 'tournament', hard: true }),
      );
    }
  }
}

/** A soft radial glow behind the menus, reused across non-battle scenes. */
export function backdropGlow(scene: Phaser.Scene): void {
  const g = scene.add.graphics();
  for (let i = 30; i >= 0; i--) {
    g.fillStyle(0x2a3a66, (i / 30) * 0.04);
    g.fillCircle(WORLD.width / 2, WORLD.height / 2, (i / 30) * 520);
  }
}
